export const ACTIVE_WORK_ORDER_STORAGE_KEY = "activeWorkOrder";
